interface Links {
  [key: string]: {
    [key in string]: string;
  };
}

export const getLinkToCTAVillasNear = (locale: Locale, region: string, slug: string) => {
  const links: Links = process.env.NEXT_PUBLIC_COOKIES_ENV === 'prod' ? {
    en: {
      sicily: "/sicily/villas-in-sicily-near",
      puglia: "/puglia/villas-in-puglia-near"
    },
    it: {
      sicily: "/it/sicilia/ville-in-sicilia-vicino",
      puglia: "/it/puglia/ville-in-puglia-vicino"
    },
    de: {
      sicily: "/de/sizilien/ferienhaeuser-auf-sizilien-in-der-naehe-von",
      puglia: "/de/apulien/ferienhaeuser-auf-apulien-in-der-naehe-von"
    },
    fr: {
      sicily: "/fr/sicile/villas-en-sicile-proches-de",
      puglia: "/fr/pouilles/villas-en-pouilles-proches-de"
    }
  } : {
    en: {
      sicily: "/sicily/villas-near",
      puglia: "/puglia/villas-near"
    },
    it: {
      sicily: "/it/sicilia/ville-vicino",
      puglia: "/it/puglia/ville-vicino"
    },
    de: {
      sicily: "/de/sizilien/ferienhaeuser-in-der-naehe-von",
      puglia: "/de/apulien/ferienhaeuser-in-der-naehe-von"
    },
    fr: {
      sicily: "/fr/sicile/villas-proches-de",
      puglia: "/fr/pouilles/villas-proches-de"
    }
  };

  return `${links[locale]?.[region]}-${slug}`;
}
